import { loadStripe, Stripe } from '@stripe/stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from 'src/config';

if (!STRIPE_PUBLISHABLE_KEY) {
  throw new Error('VITE_STRIPE_PUBLISHABLE_KEY is not defined in environment variables');
}

// Singleton instances
const stripePromises: Map<string, Promise<Stripe | null>> = new Map();

// Create a platform Stripe instance (no connected account)
export const platformStripePromise = () => {
  if (!stripePromises.has(STRIPE_PUBLISHABLE_KEY)) {
    const promise = loadStripe(STRIPE_PUBLISHABLE_KEY);
    stripePromises.set(STRIPE_PUBLISHABLE_KEY, promise);
  }
  return stripePromises.get(STRIPE_PUBLISHABLE_KEY)!;
};

// Create a connected account Stripe instance
export const stripePromise = (connectedAccountId: string) => {
  if (!stripePromises.has(connectedAccountId)) {
    const promise = loadStripe(STRIPE_PUBLISHABLE_KEY, {
      stripeAccount: connectedAccountId,
    });
    stripePromises.set(connectedAccountId, promise);
  }

  return stripePromises.get(connectedAccountId)!;
};
